import { useState } from "react";
import ModalWindow from "../../common/ModalWindow";

const DeclineWorkOrderWindow: React.FC<{
  setShowDeclineWorkOrderWindow: any;
  onDeclineWorkOrder: any;
}> = ({ setShowDeclineWorkOrderWindow, onDeclineWorkOrder }) => {
  const [declineWorkOrderReasonIndex, setDeclineWorkOrderReasonIndex] =
    useState<number>(-1);

  const [declineWorkOrderReason, setDeclineWorkOrderReason] = useState<
    string | undefined
  >();

  const onDeclineWorkOrderReasonClick = (index: number, reason: string) => {
    setDeclineWorkOrderReasonIndex(index);
    setDeclineWorkOrderReason(reason);
  };

  const htmlTdDeclineOrderOption = (index: number, reason: string) => {
    return (
      <td
        className={
          "option-cell" +
          (declineWorkOrderReasonIndex === index ? " option-cell-active" : "")
        }
        onClick={() => onDeclineWorkOrderReasonClick(index, reason)}
      >
        {reason}
      </td>
    );
  };

  const onDeclineWorkOrderOk = async () => {
    await onDeclineWorkOrder(declineWorkOrderReason);
    setShowDeclineWorkOrderWindow(false);
  };

  const onDeclineWorkOrderCancel = () => {
    setShowDeclineWorkOrderWindow(false);
  };

  return (
    <ModalWindow
      title="Decline Work Order"
      okTitle="Decline"
      onOk={onDeclineWorkOrderOk}
      onCancel={onDeclineWorkOrderCancel}
      isOkEnabled={declineWorkOrderReasonIndex !== -1}
      isLarge={true}
    >
      <div>
        <div className="mb-2" style={{ fontWeight: "bold" }}>
          Select Decline Reason
        </div>
        <table className="option-table" style={{ width: "100%" }}>
          <tbody>
            <tr>
              {htmlTdDeclineOrderOption(1, "Cannot meet response window")}
            </tr>
            <tr>
              {htmlTdDeclineOrderOption(2, "Work Order info incorrect")}
              {htmlTdDeclineOrderOption(
                3,
                "Account issue - not accepting work"
              )}
            </tr>
            <tr>
              {htmlTdDeclineOrderOption(4, "Out of scope")}
              {htmlTdDeclineOrderOption(5, "Duplicate Work Order")}
            </tr>
            <tr>{htmlTdDeclineOrderOption(6, "Out of area")}</tr>
          </tbody>
        </table>
      </div>
    </ModalWindow>
  );
};

export default DeclineWorkOrderWindow;
